import {DropDownArrow} from '../../styles/icons';

export default function DropDownMenu({title, dropDownOptions = [], toggleDropDown, dropDownToggle, onClickOption}) {


    return (
        <div className='drop-down'>
            <div onClick={toggleDropDown}>
                <div className='d-flex flex-row align-items-center cursor-pointer drop-down-title maxis-bold'>
                    {title} <DropDownArrow width={14} height={14} />
                </div>
            </div>
            <div className={`options ${dropDownToggle ? 'visible' : ''}`}>
                {dropDownOptions.map((option, index) => {
                    return (
                        <div key={index} className='option-label maxis-bold' onClick={() => onClickOption(option.url)}>
                            {option.label}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
